import styled from "styled-components";
import { Column } from "uikit";

const InformationContainer = styled(Column)`
	overflow: hidden;
`;

export default InformationContainer;
